import React from "react";
import ContentLoader from "react-content-loader";

export const TextInputSkeleton = (props) => (
  <ContentLoader
    speed={2}
    style={{ width: props.width ? props.width : "100%" }}
    height={30}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <path d="M 0 0 h 1723 v 30 H 0 z" />
  </ContentLoader>
);
